export default __webpack_public_path__ + "static/media/offer.e5631d3c.svg";